import React from 'react';
import styles from './ButtonBack.module.scss';

export default ({ label }) => {
  return <button className={styles.host}>{label}</button>;
};
